const CHECKOUT_HOSTS = [
  "billing.sifted.eu",
  "buy.stripe.com",
  "checkout.stripe.com",
];

export const isCheckoutUrl = (url?: string | null) => {
  const trimmed = url?.trim();

  if (!trimmed) {
    return false;
  }

  try {
    const { hostname } = new URL(trimmed, "https://sifted.eu");

    return CHECKOUT_HOSTS.includes(hostname.toLowerCase());
  } catch {
    return false;
  }
};
